var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signal-r-disconnected-screen",class:{ 'show': _vm.shouldShow }},[_c('div',[_c('a-spin',{attrs:{"size":"large"}}),_c('h1',[_vm._v("Connecting...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }